// InfoBanner.js
import React from "react";
import "./../component_styles/InfoBanner.css";
import { FaPhoneAlt, FaFax, FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import useWindowDimensions from "../../hooks/useWindowDimensions";

const InfoBanner = () => {
  const navigate = useNavigate();
  const { width, height } = useWindowDimensions();

  return (
    <div className="info-banner">
      <div
        className={
          width >= 1140 ? "info-banner-content" : "info-banner-content-small"
        }
      >
        <div className="info-banner-test-options">
          <div className="info-banner-test">
            <div
              className="info-banner-info"
              onClick={() => navigate("/consultation")}
            >
              Prescribing Pharmacist <span className="fow">→</span>
              {/* <FaArrowRight className="info-banner-arrow" /> */}
            </div>
          </div>
          <div className="info-banner-test">
            <div
              className="info-banner-info"
              onClick={() => navigate("/about#compounding")}
            >
              Compounding <span className="fow">→</span>
            </div>
          </div>
          <div className="info-banner-test">
            <div
              className="info-banner-info"
              // When clicked, this will scroll to the VaccinationSection
              onClick={() =>
                window.open("https://www.virtualtravelclinic.ca", "_blank")
              }
            >
              Virtual Travel Clinic <span className="fow">→</span>
              {/* <FaArrowRight className="info-banner-arrow" /> */}
            </div>
          </div>
        </div>
        {width >= 1140 && (
          <>
            <div className="info-banner-contact">
              <div className="info-banner-slant">
                <FaPhoneAlt className="info-banner-icon" />
                <div className="info-banner-contact-text">
                  <span className="info-banner-phone">(905) 749-9990</span>
                  {width > 1412 ? (
                    <p className="info-banner-call-text">Call Us</p>
                  ) : (
                    <p className="info-banner-call-text">Fax: (905) 749-9001</p>
                  )}
                </div>
              </div>
            </div>
            {width > 1412 && (
              <div className="info-banner-contact">
                <div className="info-banner-slant-2">
                  <FaFax className="info-banner-icon-2" />
                  <div className="info-banner-contact-text">
                    <span className="info-banner-phone">(905) 749-9001</span>
                    <p className="info-banner-call-text">Fax </p>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InfoBanner;
